import { useEffect, useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";

import { selectUser } from "../../store/slices/userSlice";
import Api from "../../helpers/Api";

import styles from "./styles.module.css";
import imagemCadastro from "../../assets/imagemCadastro.png";
import { setIsClinicConnectionsComplete } from "../../store/slices/isClinicConnectionsCompleteSlice";

export function Cadastro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector(selectUser);

  const [payloadStep1, setPayloadStep1] = useState([]);
  const [payloadStep2, setPayloadStep2] = useState([]);
  const [payloadStep1AndStep2, setPayloadStep1AndStep2] = useState({
    step1: payloadStep1,
    step2: payloadStep2,
  });
  const [nextStep, setNextStep] = useState("step1");
  const [userDetails, setUserDetails] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const userDetailsStep1 = {
    nome: userDetails?.data?.nome,
    documento: userDetails?.data?.documento,
  };

  const userDetailsStep2 = {
    cep: userDetails?.data?.cep,
    email: userDetails?.data?.email,
    cidade: userDetails?.data?.cidade,
    estado: userDetails?.data?.estado,
    fone: userDetails?.data?.fone,
  };

  const handleToJump = () => {
    navigate("/dashboard");
  };

  const getPayloadStep1 = (values: any) => {
    setPayloadStep1(values);
    setNextStep("step2");
  };

  const getPayloadStep2 = (values: any) => {
    setPayloadStep2(values);
    // setNextStep("step3");
  };

  const handleBackButtonStep1 = () => {
    setNextStep("step1");
  };

  const handleBackButtonStep2 = () => {
    setNextStep("step2");
  };

  const getUserDetails = async () => {
    setLoading(true);
    const hash = user[0]?.hash;
    const idClient = user[0]?.idClient;

    if (hash) {
      const payload = {
        idClient,
        hash,
      };

      try {
        const result = await Api.GetUserDetails(payload);

        if (result.isSuccess === true) {
          setUserDetails(result);
        } else {
          console.error(
            "A requisição não foi bem-sucedida:",
            result.errorMessage
          );
        }

        setLoading(false);
      } catch (error) {
        console.error("Erro ao fazer a requisição:", error);
        setLoading(false);
      }
    } else {
      console.error("Hash não é verdadeiro ou está indefinido.");
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  useEffect(() => {
    setPayloadStep1AndStep2({
      step1: payloadStep1,
      step2: payloadStep2,
    });
  }, [payloadStep1, payloadStep2]);

  useEffect(() => {
    setIsClinicConnectionsComplete(false);
  }, [])

  const currentStep = () => {
    switch (nextStep) {
      case "step1":
        return (
          <Step1
            handleToJump={handleToJump}
            userDetailsStep1={userDetailsStep1}
            getPayload={getPayloadStep1}
            payloadStep1={payloadStep1}
          />
        );
      case "step2":
        return (
          <Step2
            payloadStep1={payloadStep1}
            getPayload={getPayloadStep2}
            userDetailsStep2={userDetailsStep2}
            handleBackButtonStep1={handleBackButtonStep1}
            payloadStep2={payloadStep2}
          />
        );
      case "step3":
        return (
          <Step3
            payloadStep1AndStep2={payloadStep1AndStep2}
            handleBackButtonStep2={handleBackButtonStep2}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {loading ? (
        <div className={styles.loading_container}>
          <div className={styles.containerImage}>
            <img src="/logo_serodonto_verde.png" width={"200px"} />
          </div>
          <div className={styles.loading_spinne}></div>
          <p>
            Carregando... <br />
            Preparando a página de cadastro.
          </p>
        </div>
      ) : (
        <div className={styles.containerGeral}>
          {user !== false && user !== undefined && (
            <XMarkIcon
              title="Pular"
              onClick={handleToJump}
              className={styles.iconClose}
            />
          )}
          <div className={styles.containerImagem}>
            <img
              src={imagemCadastro}
              alt=""
            />
          </div>

          <div className={styles.containerForm}>
            <div className={styles.headerForm}>
              <svg
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.logo}
              >
                <path
                  d="M63.9995 32.1964C63.9416 49.8062 49.6465 63.7549 32.6663 63.9964C14.1794 64.2668 -0.067372 49.4971 0.000239648 31.8487C0.0678513 14.2099 14.4885 -0.086513 32.1737 0.000424934C49.6755 0.0873628 64.0961 14.3935 63.9995 32.1964ZM51.6266 26.2267C51.5686 25.1545 51.5203 24.2175 51.472 23.2805C51.3755 21.4644 51.0567 19.7063 50.3999 18.0062C49.8107 16.48 49.0284 15.0793 47.792 13.9684C46.6233 12.9252 45.2807 12.2683 43.716 12.1814C42.132 12.1041 40.5479 12.1621 38.9929 12.5968C37.8241 12.9155 36.7134 13.3695 35.6702 13.9684C34.4242 14.6736 33.3425 15.6009 32.309 16.5669C32.0771 16.7794 31.9129 16.7794 31.6908 16.5669C31.2272 16.1322 30.7539 15.7169 30.271 15.3112C28.9091 14.1616 27.3733 13.3116 25.6734 12.7706C24.099 12.2683 22.4763 12.1138 20.8246 12.1524C18.1105 12.22 16.1498 13.5627 14.7203 15.7748C13.7061 17.3494 13.1362 19.0978 12.8175 20.9525C12.547 22.527 12.4408 24.1112 12.4311 25.7051C12.4118 28.5547 12.6629 31.3753 13.1845 34.1767C13.5709 36.2439 14.0924 38.2821 14.7686 40.272C15.5123 42.4648 16.4202 44.5996 17.502 46.6474C18.6514 48.8305 19.9747 50.8881 21.4621 52.849C21.6553 53.1002 21.974 53.2934 22.2735 53.4189C23.0848 53.757 23.8865 53.5928 24.6592 53.2547C25.1035 53.0615 25.4029 52.7138 25.5092 52.2115C25.6057 51.7091 25.7023 51.2068 25.7893 50.7045C26.2143 48.1737 26.6779 45.6525 27.6438 43.2569C28.0977 42.1267 28.6966 41.0834 29.6528 40.2913C30.609 39.4895 31.7198 39.2577 32.9078 39.5378C34.1248 39.8276 34.9265 40.668 35.593 41.6823C36.4719 43.025 36.9548 44.5319 37.3122 46.0582C37.7565 47.9612 38.0946 49.8931 38.4326 51.8154C38.5872 52.6751 39.0218 53.2161 39.8621 53.4382C40.007 53.4769 40.1616 53.5252 40.3065 53.5542C41.1468 53.728 41.9195 53.5928 42.5087 52.9359C42.8177 52.5978 43.0882 52.2115 43.3393 51.8251C44.2279 50.4534 45.1552 49.101 45.9762 47.6907C46.5943 46.6378 47.1256 45.5366 47.6085 44.416C48.2267 42.9864 48.8255 41.5471 49.3181 40.0691C49.7817 38.6974 50.1584 37.2871 50.4675 35.8768C50.8249 34.254 51.1533 32.6118 51.3465 30.9696C51.5396 29.3661 51.559 27.7336 51.6362 26.246L51.6266 26.2267Z"
                  fill="#008F79"
                />
              </svg>
              <p>
                Área de Cadastro
              </p>
            </div>

            {currentStep()}
          </div>
        </div>
      )}
    </>
  );
}
